import React, { useMemo, useState } from 'react';
import { TMfaConnectModalStep } from './types';
import { SelectConnectType } from './Steps/SelectConnectType';
import { TOTPConnectDevice } from './Steps/TOTPConnectDevice';
import { TOTPQr } from './Steps/TOTPQr';

type Props = {
  onClose?: () => void;
  onGoBack(): void;
};

export const MfaConnectModalConnection = (props: Props) => {
  const { onGoBack } = props;
  const [step, setStep] = useState<TMfaConnectModalStep>('type');

  const content = useMemo(() => {
    switch (step) {
      case 'device':
        return <TOTPConnectDevice setFormStep={setStep} />;
      case 'qr':
        return <TOTPQr setFormStep={setStep} />;
      case 'type':
      default:
        return <SelectConnectType setFormStep={setStep} onGoBack={onGoBack} />;
    }
  }, [step]);

  return content;
};
